import { useState, useEffect } from 'react';

export const useFilters = (initialFilters) => {
    const [filters, setFilters] = useState(initialFilters);
    const [selectedCategory, setSelectedCategory] = useState("");

    useEffect(() => {
        setFilters(initialFilters);
    }, [initialFilters]);

    const handleFilterChange = (sectionTitle, value, checked) => {
        setFilters(prevFilters =>
            prevFilters?.map(section =>
                section?.name === sectionTitle
                    ? {
                        ...section,
                        options: section?.options?.map(option => ({
                            ...option,
                            checked: section.type === 'single' ? option.value === value && checked : option.value === value ? checked : option.checked
                        }))
                    }
                    : section
            )
        );
    };

    const resetFilters = () => {
        const reset = filters.map(section => ({
            ...section,
            options: section.options.map(option => ({
                ...option,
                checked: false
            }))
        }));
        setFilters(reset);
    };

    return {
        filters,
        selectedCategory,
        setSelectedCategory,
        handleFilterChange,
        setFilters,
        resetFilters // Añadir resetFilters a los retornos
    };
};